import { createAsyncThunk } from '@reduxjs/toolkit'
import { IPerformerDataActiveEvents, IPerformerMetadata } from 'meta/pages/v4/performer'
import { RootState } from 'store/types'
import { PerformerController } from 'controller/performer/controller'

type Params = {
  code: string
  page: number
}

type Returned = {
  data: IPerformerDataActiveEvents,
  metadata: IPerformerMetadata,
  code: string
}

export const getActiveEvents = createAsyncThunk<Returned, Params, { state: RootState }>(
  'performer/getActiveEvents',
  async (params) => {
    const { code, page } = params

    const { data, metadata } = await PerformerController.getActiveEvents({ code, page })

    return { data, metadata, code }
  }
)
